import _ from 'lodash';

import { PLAN_TYPES } from 'shared/components/ChangePlanModal/constants';

export const userHasPlan = (user, planType) => {
  return _.get(user, 'plan_subscription.plan_type') === planType.value;
};

export const isPaidPlan = user => {
  return (
    user &&
    user.plan_subscription.plan_type !==
      _.find(PLAN_TYPES, { label: 'Free' }).value
  );
};
